var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDonationSession = function SvgDonationSession(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110407)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2139 12)",
    fill: "url(#paint0_linear_10345_110407)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2139 48)",
    fill: "url(#paint1_linear_10345_110407)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2752 47.0875L70.1555 46.8553C70.4413 47.3243 70.5431 47.9887 70.4461 48.7506C70.3493 49.5102 70.0599 50.3268 69.6203 51.0805L66.163 57.1439C65.8738 57.6417 65.4832 58.0529 65.076 58.2879C64.6689 58.523 64.2783 58.5629 63.9892 58.3989L63.9837 58.3958L60.5337 56.3289C60.0901 56.0898 59.7954 55.6135 59.693 54.9699C59.5901 54.3232 59.6867 53.5419 59.9686 52.7414L59.9713 52.7337C60.1926 52.118 60.5099 51.5137 60.8977 50.9692C61.2855 50.4247 61.733 49.9552 62.2043 49.5983C62.6756 49.2415 63.1575 49.0073 63.6114 48.9145C64.0652 48.8217 64.4784 48.8729 64.8178 49.064L64.8202 49.0654L65.076 49.2131L65.3381 48.7592C65.6775 48.1836 66.0886 47.6629 66.539 47.2379C66.9894 46.8129 67.4669 46.4954 67.9337 46.3104C68.4005 46.1254 68.8439 46.0779 69.229 46.1717C69.6141 46.2656 69.9304 46.4981 70.1528 46.8511L70.2752 47.0875Z",
    fill: "url(#paint2_linear_10345_110407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7709 56.9137C65.5861 57.2321 65.3363 57.495 65.076 57.6453C64.8156 57.7956 64.5659 57.8211 64.381 57.7162L60.9255 55.6462C60.5646 55.4541 60.325 55.0685 60.2419 54.5464C60.1589 54.0244 60.2369 53.3937 60.4644 52.7475C60.6453 52.2442 60.9047 51.7502 61.2218 51.305C61.5388 50.8599 61.9046 50.476 62.2899 50.1843C62.6752 49.8926 63.0691 49.7011 63.4402 49.6253C63.8112 49.5494 64.149 49.5913 64.4264 49.7475L65.076 50.1225L65.7255 48.9975C66.0029 48.5269 66.339 48.1012 66.7072 47.7537C67.0754 47.4063 67.4657 47.1468 67.8474 46.9955C68.229 46.8442 68.5915 46.8054 68.9063 46.8821C69.2212 46.9588 69.4797 47.149 69.6616 47.4375V47.4375C69.8923 47.8161 69.9745 48.3524 69.8962 48.9675C69.8178 49.5825 69.583 50.2438 69.2264 50.8537L65.7709 56.9137Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7172 68.5312L58.4182 67.4962C58.0005 67.1406 57.7714 66.5295 57.7687 65.7637L57.7687 61.8862C57.7687 61.5879 57.8713 61.2425 58.054 60.926C58.2367 60.6095 58.4846 60.3479 58.743 60.1987V60.1987C59.0014 60.0495 59.2492 60.025 59.4319 60.1305C59.6146 60.236 59.7172 60.4629 59.7172 60.7612L59.7172 63.6562",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6398 66.8438L62.6398 64.5938C62.641 63.9252 62.4691 63.3714 62.1462 63.0038L61.4057 62.1188C61.3429 62.0302 61.2583 61.9706 61.1573 61.9437C61.0563 61.9169 60.9411 61.9234 60.819 61.9629C60.6969 62.0024 60.5705 62.074 60.4479 62.1731C60.3252 62.2722 60.2091 62.3968 60.1067 62.5388V62.5388C59.923 62.7874 59.7907 63.0787 59.7345 63.3583C59.6783 63.6379 59.7021 63.8865 59.8014 64.0575L60.6782 65.2388",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4347 62.3437L71.7337 59.8087C72.1514 58.9708 72.3805 58.0951 72.3832 57.3262L72.3832 53.4487C72.3832 53.1504 72.2806 52.9235 72.0979 52.818C71.9152 52.7125 71.6674 52.737 71.409 52.8862C71.1506 53.0354 70.9028 53.297 70.7201 53.6135C70.5373 53.93 70.4347 54.2754 70.4347 54.5737L70.4347 57.4687",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5115 64.0311L67.5115 61.7811C67.5102 61.114 67.6822 60.3617 68.0051 59.6211L68.7456 57.8811C68.8084 57.72 68.893 57.5627 68.994 57.4193C69.0949 57.2758 69.2102 57.1493 69.3323 57.0478C69.4544 56.9463 69.5808 56.8719 69.7034 56.8295C69.826 56.787 69.9422 56.7773 70.0446 56.8011V56.8011C70.2282 56.8377 70.3605 56.9763 70.4167 57.191C70.4729 57.4057 70.4492 57.6817 70.3499 57.9674L69.473 60.1611",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0381 30)",
    fill: "url(#paint3_linear_10345_110407)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110407",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.415686 0 0 0 0 0.411765 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110407",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110407",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF656C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110407",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF656C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4616D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110407",
    x1: 70.4818,
    y1: 55.164,
    x2: 60.5942,
    y2: 49.4115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10345_110407",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4751"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDonationSession);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "donation_session.cad3ee75c1963184be1e4b38fe8a25a3.svg";